import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=0ddaf735"
import script from "./UiIcon.vue?vue&type=script&lang=ts"
export * from "./UiIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports